import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Tooltip, Typography } from '@mui/material';
import Box from '@mui/material/Box';
import { useMemo } from 'react';
import usePButtonGroupStyles from './useButtonStyles';
import { BranchedIndicator } from '../BranchedIndicator';
export const PButtonGroup = ({ options, label, parentOptionId, parentFieldLabel, parentOptionLabel }) => {
    const styles = usePButtonGroupStyles();
    const optionCount = options.length;
    const gridTemplateColumns = useMemo(() => ({
        xs: `repeat(${Math.max(1, Math.min(optionCount, 2))}, minmax(0, 1fr))`,
        md: `repeat(${Math.max(1, Math.min(optionCount, 3))}, minmax(0, 1fr))`
    }), [optionCount]);
    return (_jsx(Box, { sx: {
            ...styles.root,
            display: 'flex',
            alignItems: 'flex-start',
            gap: 0.5
        }, children: _jsxs(Box, { sx: { flex: 1, minWidth: 0 }, children: [_jsxs(Box, { display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1, children: [_jsx(Typography, { variant: 'subtitle2', sx: styles.label, children: label }), _jsx(BranchedIndicator, { parentOptionId: parentOptionId, parentFieldLabel: parentFieldLabel, parentOptionLabel: parentOptionLabel })] }), _jsx(Box, { sx: { ...styles.container, gridTemplateColumns }, children: options.map((option, idx) => (_jsx(Box, { sx: styles.option, children: _jsx(Tooltip, { title: option, arrow: true, placement: 'top', children: _jsx(Typography, { noWrap: true, sx: {
                                    minWidth: 0,
                                    maxWidth: '100%',
                                    fontSize: 14,
                                    fontWeight: 500,
                                    color: 'inherit'
                                }, children: option }) }) }, idx))) })] }) }));
};
